import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-add-sitewellawareid',
    templateUrl: './add-sitewellawareid.component.html',
    styleUrls: ['./add-sitewellawareid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSitewellawareidComponent {

  siteWellawareId: string = "";

  @Output() closeModal = new EventEmitter<any>();

  constructor() { }

  close(): void {
    this.closeModal.emit();
  }

  addSiteWellawareId(): void {
    this.closeModal.emit(this.siteWellawareId);
  }

  isValid(): boolean {
    return this.siteWellawareId != null && this.siteWellawareId != '';
  }

}
